(function(window, $) {

    /**
     * 메인메뉴
     * @type {{init: init, hover: hover, activeOff: activeOff, activeOn: activeOn}}
     */
    var gnb = {
        init: function (id) {
            this.id = id;

            this.hover(
                this.id + ' li'
            )
        },
        hover: function (target, speed) {
            var _self = this,
                $target = $(target),
                $container = $(_self.id);

            _self.speed = speed || 300;

            $target.each(function() {
                if (findChildren($(this))) {
                    return;
                }
                $(this).addClass('noDepth');
            });

            function findChildren(el) {
                return el.find('> ul').length > 0;
            }

            $container
                .mouseenter(conHandlerIn)
                .mouseleave(conHandlerOut);
            $container
                .focusin(conHandlerIn)
                .focusout(conHandlerOut);
            $target
                .mouseenter(handlerIn)
                .mouseleave(handlerOut);
            $target
                .focusin(handlerIn)
                .focusout(handlerOut);

            function conHandlerIn (e) {
                var curHeight = $('header').height(),
                    autoHeight = $('header').css('height', 'auto').height();

                $('body').addClass('gnb-on');
                $('header')
                    .height(curHeight)
                    .stop()
                    .animate({height: autoHeight}, _self.speed);

                $container.find('> li').each(function () {
                    $(this).css('height', autoHeight - 40)
                })
            }
            function conHandlerOut (e) {
                $('body').removeClass('gnb-on');
                $('header')
                    .stop()
                    .animate({height : 100}, _self.speed);

                $container.find('> li').each(function () {
                    $(this)
                        .animate({height : 'auto'}, _self.speed);
                })
            }
            function handlerIn (e) {
                 $(this).addClass('on');
                _self.activeOn($(this));
            }
            function handlerOut (e) {
                $(this).removeClass('on');
                _self.activeOff($(this));
            }
        },
        activeOff: function ($target) {
            $target.parent().removeClass('on');
        },
        activeOn: function ($target) {
            $target.parent().addClass('on');
        }
    };

    /**
     * 서브메뉴
     * @type {{init: init, load: load, hover: hover, activeOff: activeOff, activeOn: activeOn}}
     */
    var lnb = {
        init: function (id) {
            this.id = id;

            this.load();
            this.hover(
                this.id + ' li',
                300
            )
        },
        load: function () {
            var _self = this,
                $target = $(_self.id).find('> li');

            $target
                .css('width', (100/$target.length) + '%');
        },
        hover: function (target, speed) {
            var _self = this,
                $target = $(target);

            _self.speed = speed || 300;

            $target.each(function() {
                if (findChildren($(this))) {
                    return;
                }
                $(this).addClass('noDepth');
            });

            function findChildren(obj) {
                return obj.find('> ul').length > 0;
            }

            $target
                .mouseenter(handlerIn)
                .mouseleave(handlerOut);
            $target
                .focusin(handlerIn)
                .focusout(handlerOut);

            function handlerIn(e) {
                $(this).addClass('on');
                _self.activeOn($(this));
            }
            function handlerOut(e) {
                $(this).removeClass('on');
                _self.activeOff($(this));
            }
        },
        activeOff: function($target) {
            $target.parent().removeClass('on');
        },
        activeOn: function($target) {
            $target.parent().addClass('on');
        }
    };


    /**
     * 모바일 전체메뉴
     * @type {{init: init, click: click, activeOff: activeOff, activeOn: activeOn, removeLink: removeLink}}
     */
    var gnbMobile = {
        init: function (id) {
            this.id = id;

            this.click(
                this.id + ' li',
                300
            );

            this.removeLink(
                this.id
            )
        },
        click: function (target, speed) {
            var _self = this,
                $target = $(target);

            _self.speed = speed || 300;

            $target.each(function () {
                if (findChildren($(this))) {
                    return;
                }
                $(this).addClass('noDepth');
            });

            function findChildren(obj) {
                return obj.find('> ul').length > 0;
            }

            $target.on('click', 'a', function (e) {
                e.stopPropagation();
                var $this = $(this),
                    $depthTarget = $this.next(),
                    $siblings = $this.parent().siblings();

                $this.parent('li').find('ul li').removeClass('on');
                $siblings.removeClass('on');
                $siblings.find('ul').slideUp(250);

                if ($depthTarget.css('display') == 'none') {
                    _self.activeOn($this);
                    $depthTarget.slideDown(_self.speed);
                } else {
                    $depthTarget.slideUp(_self.speed);
                    _self.activeOff($this);
                }

            })

        },
        activeOff: function($target) {
            $target.parent().removeClass('on');
        },
        activeOn: function($target) {
            $target.parent().addClass('on');
        },
        removeLink: function (obj) {
            obj
                .find('li:has(ul) > a')
                .replaceWith(function() {return $(this).text()})
        }
    };

    /**
     * Page Layout
     * @type {{init: init, setPageLayout: setPageLayout, registerEvent: registerEvent, handleMenu: handleMenu, resizing: resizing}}
     */
    var pageLayout = {
        init: function () {
            this.setPageLayout();
            this.registerEvent();
            this.handleMenu();
            this.resizing();
        },
        setPageLayout: function () {
            $('html').removeClass('no-js');

            /* 콘텐츠 영역 높이 설정 */
            var $header = $('header'),
                $footer = $('footer'),
                $content = $('main');

            //리셋
            $content.css('min-height', '100%');

            var headerH = $header.height() || 0,
                footerH = $footer.height() || 0,
                contentH = $content.height() || 0,
                contentMinH = $(window).height() - headerH - footerH;

            if (contentH < contentMinH) {
                $content.css('min-height', contentMinH + 'px');
            }

            /**
             * 사이드바 스크롤 영역 높이 설정
             * https://github.com/rochal/jQuery-slimScroll
             * @type {number}
             */
            var $sidebar = $('#sidebarRight'),
                scrollableH = $sidebar.height();
                // scrollableH = $sidebar.height() - 111;

            //리셋
            $sidebar.css('min-height', 'auto');

            $sidebar.find('.sidebar-body').slimScroll({
                height: scrollableH,
                opacity: 0.3,
                size : 0,
                wheelStep: 10,
                allowPageScroll: true,
                alwaysVisible: true
            })
        },
        registerEvent: function () {
            /* 사이드바 열기/닫기 */
            $('.sidebar-toggle').on('click', function() {
                $('body').toggleClass('sidebar-active');
                $('#sidebar-close').focus();
            });
            $('#sidebar-close').on('click', function() {
                $('body').removeClass('sidebar-active');
                $('.sidebar-toggle').focus();
            });
            $('#sidebar-close-bottom').on('click', function() {
                $('body').removeClass('sidebar-active');
                $('.sidebar-toggle').focus();
            })

            /* 상단 통합검색폼 열기/닫기 */
            $('.search-toggle').on('click', function (e) {
                e.stopPropagation();
                $('body').toggleClass('searchbar-active');
                $('#searchbar').find('input[type="text"]').focus();
            });
            $('.search-close').on('click', function (e) {
                $('body').removeClass('searchbar-active');
            });
        },
        handleMenu: function () {
            //Call gnb
            gnb.init('#mainMenu');

            //Call lnb
            lnb.init('#subMenu');

            //Call gnbMobile
            gnbMobile.click('#mobileMenu li');
        },
        resizing: function () {
            var _self = this, resizeEnd;
            $(window).on('resize click', function (e) {
                clearTimeout(resizeEnd);
                resizeEnd = setTimeout(_self.setPageLayout(), 50);
            })
        }
    };

    //document ready
    $(function() {
        //Call pageLayout
        pageLayout.init();
    });

})(window, jQuery);
